export default __webpack_public_path__ + "static/media/shenzhen.cb94af47.png";